import { DebitCardInformation } from "@/types";
import { CoreFieldProps, fieldTypes, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";
import { useAddressApiClient } from "@/hooks/useAddressApiClient";

export interface DebitCardInformationComplexValue {
  readOnly?: boolean;
  showHeader?: boolean;
  shouldShowBusinessName?: boolean;
  shouldShowDebitCardFields?: boolean;
  headerLabel?: string;
}

export interface DebitCardInformationComplexFieldProps
  extends fieldTypes.BaseFieldProps<DebitCardInformation> {}

export const DebitCardInformationComplexField: FC<DebitCardInformationComplexFieldProps> = (
  props
) => {
  const debitCardInformationComplexValue =
    props.complexFieldValue as DebitCardInformationComplexValue;
  const readOnly = debitCardInformationComplexValue?.readOnly || props.readOnly;
  const shouldShowBusinessName = debitCardInformationComplexValue?.shouldShowBusinessName ?? false;
  const shouldShowDebitCardFields = debitCardInformationComplexValue?.shouldShowDebitCardFields;

  const { getAddressesByQuery, getAddressByQuery } = useAddressApiClient();

  return (
    <section className="complex-field-container debit-card-information">
      <SectionHeader label={debitCardInformationComplexValue?.headerLabel || props.label} hidden={!debitCardInformationComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.DEBIT_CARD_INFORMATION.HAS_DEBIT_CARD}
          complexFieldProps={{ disabled: readOnly }}
        />

        {/* If hasDebitCard is true, show the following fields */}
        {shouldShowDebitCardFields && (
          <>
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.DEBIT_CARD_INFORMATION.DEBIT_CARD_NAME_DISPLAYED}
              complexFieldProps={{
                hidden: !props.value?.hasDebitCard,
                disabled: readOnly,
              }}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.DEBIT_CARD_INFORMATION.BUSINESS_NAME_DISPLAYED_ON_CARD}
              complexFieldProps={{
                hidden: !props.value?.hasDebitCard || !shouldShowBusinessName,
                disabled: readOnly,
              }}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.DEBIT_CARD_INFORMATION
                  .USE_HOME_ADDRESS_FOR_DEBIT_CARD_MAILING_ADDRESS
              }
              complexFieldProps={{
                hidden: !props.value?.hasDebitCard,
                disabled: readOnly,
                showClearButton: true,
              } as Partial<CoreFieldProps>}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.DEBIT_CARD_INFORMATION.DEBIT_CARD_MAILING_ADDRESS}
              complexFieldProps={
                {
                  hidden: !props.value?.hasDebitCard || props.value?.useHomeAddressForDebitCardMailingAddress === true,
                  disabled: props.value?.useHomeAddressForDebitCardMailingAddress === true || readOnly,
                  getAddressesByQuery,
                  getAddressByQuery,
                } as any
              }
            />
          </>
        )}
      </div>
    </section>
  );
};
